import axios from "axios";
import { SearchRequest } from "../models/SearchRequest";
import { RoundTripFlightMatch } from "../models/RoundTripFlightMatch";
import { API_BASE_URL } from "../config/api";

export class FlightSearchService {
  static async discoverFlights(payload: SearchRequest): Promise<RoundTripFlightMatch[]> {
    const response = await axios.post<RoundTripFlightMatch[]>(`${API_BASE_URL}/flights/discover`, payload, {timeout: 60000});
    return response.data;
  }
  static async searchFlights(payload: SearchRequest): Promise<RoundTripFlightMatch[]> {
    try {
      const response = await axios.post<RoundTripFlightMatch[]>(
        `${API_BASE_URL}/search`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("FlightSearchService error:", error);
      throw new Error(
        error.response?.data?.message || "An error occurred while searching for flights."
      );
    }
  }

  static async compareFlights(payload: SearchRequest): Promise<RoundTripFlightMatch[]> {
    try {
      const response = await axios.post<RoundTripFlightMatch[]>(
        `${API_BASE_URL}/flights/compare`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log(response);
      return response.data;
    } catch (error: any) {
      console.error("FlightSearchService compareFlights error:", error);
      throw new Error(error.response?.data?.message || "An error occurred while comparing flights.");
    }
  }

}
